var styles = {"fontElementMap":"Svb4u","orderedlist":"RTGr8","bulletedlist":"IgIrR","listItem":"dQlvX"};

export { styles as s };
//# sourceMappingURL=lists-0d5b5bc9.js.map
